<template>
  <div
    v-if="buttonOption && Object.keys(buttonOption).length"
    :class="`btn-trigger-wrap ${buttonOption.Alignment} ${sectionKey === activeButtonSectionKey && buttonId === activeButtonId ? 'active' : ''}`"
  >
    <div :class="buttonOption.ImageAlignment" :style="{ width: `${buttonOption.Width === 'fill' ? '100%' : 'auto'}` }">
      <a :class="getClassName" :data-section="sectionKey" :data-id="buttonId" :href="getHref" :style="renderStyles" :target="getTarget" @click="clickButton">
        <div>
          <i
            v-if="buttonOption.Icon"
            :class="`fa ${getIconExtra(buttonOption.Icon)} fa-${getIconName(buttonOption.Icon)}`"
            :style="{
              color: buttonOption.TextColor || theme.ButtonTextColor,
              fontSize: `${buttonOption.IconSize || 14}px`,
              marginRight: '10px',
            }"
          />
          <div>
            <span
              v-if="buttonOption.Text"
              :style="{
                color: buttonOption.TextColor || theme.ButtonTextColor,
                fontSize: `${buttonOption.FontSize || 14}px`,
                fontWeight: 600,
                fontFamily: disableFontFamily ? '\'Poppins\', sans-serif' : buttonOption.FontFamily,
              }"
            >
              {{ buttonOption.Text }}
            </span>
            <span
              v-if="buttonOption.SubText"
              :style="{
                color: buttonOption.SubTextColor || theme.ButtonTextColor,
                fontSize: `${buttonOption.SubFontSize || 14}px`,
                fontWeight: 400,
                fontFamily: disableFontFamily ? '\'Poppins\', sans-serif' : buttonOption.FontFamily,
              }"
            >
              {{ buttonOption.SubText }}
            </span>
          </div>
          <i
            v-if="buttonOption.IconAfter"
            :class="`fa ${getIconExtra(buttonOption.IconAfter)} fa-${getIconName(buttonOption.IconAfter)}`"
            :style="{
              color: buttonOption.TextColor || theme.ButtonTextColor,
              fontSize: `${buttonOption.IconSize || 14}px`,
              marginLeft: '10px',
            }"
          />
        </div>
      </a>
      <template v-if="buttonOption.ShowImage && buttonOption.Image">
        <template v-if="buttonOption.ShowWidth && buttonOption.ShowHeight">
          <img :src="buttonOption.Image" :width="buttonOption.ShowWidth" :height="buttonOption.ShowHeight" alt="" />
        </template>
        <template v-else>
          <img :src="buttonOption.Image" alt="" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import './Styles/ButtonRenderer.scss'
import { getFullLink2 } from '@src/helper'
export default {
  props: {
    buttonOption: { type: [Object], default: null },
    sectionKey: { type: String, default: null },
    buttonId: { type: String, default: null },
    live: { type: Boolean, default: false },
    preview: { type: Boolean, default: false },
    theme: { type: [Object], default: null },
    link: { type: String, default: '' },
    renderOnly: { type: Boolean, default: false },
    disableFontFamily: { type: Boolean, default: false },
    fromLanding: { type: Boolean, default: false }
  },
  computed: {
    activeButtonSectionKey() { return this.$store.getters['utility/buttonSectionKey'] },
    activeButtonId() { return this.$store.getters['utility/buttonId'] },
    getTarget() {
      let target = '_self'
      if ((this.buttonOption.PageId || !this.buttonOption.SectionId) && this.buttonOption.OpenInNewWindow) {
        target = 'blank'
      }
      return target
    },
    getHref() {
      let href = null
      if (this.buttonOption.PageId) {
        if (this.buttonOption.PageId !== '/') {
          href = `${this.link}/${this.buttonOption.PageId}`
        } else {
          href = this.link
        }
      } else if (this.buttonOption.SectionId) {
        if (this.fromLanding) {
          href = `${this.link}/#page-${this.buttonOption.SectionId}-section`
        } else {
          href = `#page-${this.buttonOption.SectionId}-section`
        }
      } else if (this.buttonOption.CustomLink) {
        href = getFullLink2(this.buttonOption.CustomLink, this.link, this.fromLanding)
      }
      return href
    },
    getClassName() {
      let className = 'btn-trigger'
      if (this.buttonOption.HoverClass) {
        className += ` ${this.buttonOption.HoverClass}`
      }
      if (this.renderOnly) {
        className += ' renderOnly'
      }
      return className
    },
    renderStyles() {
      let styles = {
        backgroundColor: this.buttonOption.BackgroundColor || this.theme.ButtonBackground,
        borderStyle: this.buttonOption.BorderStyle,
        borderColor: `${this.buttonOption.BorderColor || this.theme.ButtonBorderColor}`,
        paddingTop: `${this.buttonOption.PaddingTop}px`,
        paddingBottom: `${this.buttonOption.PaddingBottom}px`,
        paddingLeft: `${this.buttonOption.PaddingLeft}px`,
        paddingRight: `${this.buttonOption.PaddingRight}px`,
        borderRadius: `${this.buttonOption.RadiusEdge !== 'bottomonly' ? this.buttonOption.BorderRadius : 0}px ${this.buttonOption.RadiusEdge !== 'bottomonly' ? this.buttonOption.BorderRadius : 0}px ${this.buttonOption.RadiusEdge !== 'toponly' ? this.buttonOption.BorderRadius : 0}px ${this.buttonOption.RadiusEdge !== 'toponly' ? this.buttonOption.BorderRadius : 0}px`,
        width: `${this.buttonOption.Width === 'fill' ? '100%' : 'auto'}`
      }
      if (!this.buttonOption.Border) {
        styles.borderWidth = '0px'
      } else if (this.buttonOption.Border === 'top') {
        styles.borderWidth = `${this.buttonOption.BorderWidth}px 0px 0px 0px`
      } else if (this.buttonOption.Border === 'bottom') {
        styles.borderWidth = `0px 0px ${this.buttonOption.BorderWidth}px 0px`
      } else if (this.buttonOption.Border === 'topbottom') {
        styles.borderWidth = `${this.buttonOption.BorderWidth}px 0px ${this.buttonOption.BorderWidth}px 0px`
      } else if (this.buttonOption.Border === 'left') {
        styles.borderWidth = `0px 0px 0px ${this.buttonOption.BorderWidth}px`
      } else if (this.buttonOption.Border === 'right') {
        styles.borderWidth = `0px ${this.buttonOption.BorderWidth}px 0px 0px`
      } else if (this.buttonOption.Border === 'leftright') {
        styles.borderWidth = `0px ${this.buttonOption.BorderWidth}px 0px ${this.buttonOption.BorderWidth}px`
      } else if (this.buttonOption.Border === 'full') {
        styles.borderWidth = `${this.buttonOption.BorderWidth}px`
      }
      if (this.buttonOption.BoxShadow) {
        styles.boxShadow = this.buttonOption.BoxShadow
      }
      if (this.buttonOption.TextShadow) {
        styles.textShadow = this.buttonOption.TextShadow
      }
      return styles
    }
  },
  methods: {
    clickButton(e) {
      if (!this.live) e.preventDefault()
    },
    getIconExtra(string) {
      if (string.split(' ').length > 1 && string.split(' ')[0] && string.split(' ')[1]) {
        return string.split(' ')[0]
      }
      return ''
    },
    getIconName(string) {
      if (string.split(' ').length > 1 && string.split(' ')[0] && string.split(' ')[1]) {
        return string.split(' ')[1]
      }
      return string
    }
  }
}
</script>